import { render } from "./InsightList.vue?vue&type=template&id=047e3666&scoped=true"
import script from "./InsightList.vue?vue&type=script&lang=js"
export * from "./InsightList.vue?vue&type=script&lang=js"

import "./InsightList.vue?vue&type=style&index=0&id=047e3666&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047e3666"]])

export default __exports__